module.exports = __webpack_public_path__ + "645976b8c6f650d5b1525601cd5d6bb0.svg";